/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ListCompaniesRow } from "./ListCompaniesRow";
import {
  ListCompaniesRowFromJSON,
  ListCompaniesRowFromJSONTyped,
  ListCompaniesRowToJSON,
  ListCompaniesRowToJSONTyped,
} from "./ListCompaniesRow";

/**
 *
 * @export
 * @interface CompanyListItemDetail
 */
export interface CompanyListItemDetail {
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  companyListItemId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  companyName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  billingCity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  billingState?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  billingPostalCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof CompanyListItemDetail
   */
  billingLatitude?: number | null;
  /**
   *
   * @type {number}
   * @memberof CompanyListItemDetail
   */
  billingLongitude?: number | null;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  temperature?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  controlsLtlFreight?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  shipmentFrequency?: string | null;
  /**
   *
   * @type {number}
   * @memberof CompanyListItemDetail
   */
  position: number;
  /**
   *
   * @type {boolean}
   * @memberof CompanyListItemDetail
   */
  done: boolean;
  /**
   *
   * @type {string}
   * @memberof CompanyListItemDetail
   */
  note?: string | null;
  /**
   *
   * @type {ListCompaniesRow}
   * @memberof CompanyListItemDetail
   */
  company?: ListCompaniesRow | null;
}

/**
 * Check if a given object implements the CompanyListItemDetail interface.
 */
export function instanceOfCompanyListItemDetail(
  value: object,
): value is CompanyListItemDetail {
  if (
    !("companyListItemId" in value) ||
    value["companyListItemId"] === undefined
  )
    return false;
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("position" in value) || value["position"] === undefined) return false;
  if (!("done" in value) || value["done"] === undefined) return false;
  return true;
}

export function CompanyListItemDetailFromJSON(
  json: any,
): CompanyListItemDetail {
  return CompanyListItemDetailFromJSONTyped(json, false);
}

export function CompanyListItemDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyListItemDetail {
  if (json == null) {
    return json;
  }
  return {
    companyListItemId: json["companyListItemId"],
    companyId: json["companyId"],
    companyName: json["companyName"] == null ? undefined : json["companyName"],
    billingCity: json["billingCity"] == null ? undefined : json["billingCity"],
    billingState:
      json["billingState"] == null ? undefined : json["billingState"],
    billingPostalCode:
      json["billingPostalCode"] == null ? undefined : json["billingPostalCode"],
    billingLatitude:
      json["billingLatitude"] == null ? undefined : json["billingLatitude"],
    billingLongitude:
      json["billingLongitude"] == null ? undefined : json["billingLongitude"],
    temperature: json["temperature"] == null ? undefined : json["temperature"],
    controlsLtlFreight:
      json["controlsLtlFreight"] == null
        ? undefined
        : json["controlsLtlFreight"],
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    position: json["position"],
    done: json["done"],
    note: json["note"] == null ? undefined : json["note"],
    company:
      json["company"] == null
        ? undefined
        : ListCompaniesRowFromJSON(json["company"]),
  };
}

export function CompanyListItemDetailToJSON(json: any): CompanyListItemDetail {
  return CompanyListItemDetailToJSONTyped(json, false);
}

export function CompanyListItemDetailToJSONTyped(
  value?: CompanyListItemDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListItemId: value["companyListItemId"],
    companyId: value["companyId"],
    companyName: value["companyName"],
    billingCity: value["billingCity"],
    billingState: value["billingState"],
    billingPostalCode: value["billingPostalCode"],
    billingLatitude: value["billingLatitude"],
    billingLongitude: value["billingLongitude"],
    temperature: value["temperature"],
    controlsLtlFreight: value["controlsLtlFreight"],
    shipmentFrequency: value["shipmentFrequency"],
    position: value["position"],
    done: value["done"],
    note: value["note"],
    company: ListCompaniesRowToJSON(value["company"]),
  };
}
